export const gerTexts = {
	knowMore: 'Mehr wissen',
	ngoPurpose:
		"To raise funds for the NGO's projects, keep you up	to date on the NGO and the progress of the project you donated to and issue tax	deduction certificates.",
	termsPurpose:
		'Manage the business relationship in all its fields, as well as its donation and certificate application, and the sending of commercial communications electronically.',
	termsRights:
		'You have the right to access, rectify and delete the data, as well as other rights, as explained in the information.',
	termsAdditionalInfo:
		'You can consult additional and detailed Data Protection information on our <a href="https://www.worldcoo.com/gdpr">website</a> or by <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>',
	unexpectedError: 'Es ist ein unerwarteter Fehler aufgetreten',
	amountError: 'Der Geldbetrag war ungültig',
	authError: 'Beim Autorisieren der Zahlung ist ein Fehler aufgetreten',
	cardError: 'Bei Ihrer Karte ist ein Fehler aufgetreten',
	referralError: 'It`s gab einen Verweisfehler',
	transactionError: 'Bei der Transaktion ist ein Fehler aufgetreten',
	resetFilters: 'Filter zurücksetzen',
	category: 'Weil',
	basicNeeds: 'Grundbedarf',
	humanRights: 'Menschenrechte',
	education: 'Bildung',
	emergency: 'Notfall',
	feeding: 'Ernährung',
	environment: 'Umwelt',
	habitat: 'Habitat',
	health: 'Gesundheit',
	clear: 'Löschen',
	active: 'Aktiv',
	finished: 'Abgeschlossen',
	status: 'Status',
	filters: 'Filter',
	year: 'Jahr',
	treesFAQ1: 'Bitte geben Sie weitere Informationen zu Conservation International („CI“) und deren Zweck an.',
	treesFAQ2: 'Was ist die Option Einen Baum zuweisen?',
	treesFAQ3: 'Werden Gebühren von meiner Spende abgezogen? Erhält die Conservation International meine volle Spende?',
	treesFAQ4:
		'Was ist Worldcoo? Warum wird meine Spende dort und nicht direkt an Conservation International weitergeleitet?',
	treesFAQ5: 'Wie erscheint diese Spende auf meinem Kontoauszug?',
	treesFAQ6: 'Was ist das passende Angebot?',
	treesFAQResponse1:
		'CI ist eine gemeinnützige Organisation für den Umweltschutz, die als Non-Profit-Organisation gemäß Abschnitt 501(c)(3) des amerikanischen Steuerrechts Internal Revenue Code anerkannt ist.  Hauptschwerpunkte von CI umfassen: (i) Umweltschutz zur Bekämpfung der Klimakrise; (ii) Schutz der Ozeane zum Schutz der Menschheit; und (iii) Vorantreiben von nachhaltigen Land- und Wassergebieten. Seit ihrer Gründung hat die Organisation dazu beigetragen, mehr als 6 Millionen Quadratkilometer (2,3 Millionen Quadratmeilen) Land und Meer in über 70 Ländern zu schützen. Mit Standorten in aktuell 29 Ländern und 2.000 Partnern weltweit verfügt Conservation International über eine globale Reichweite. Weitere Informationen finden Sie unter: https://www.conservation.org/about',
	treesFAQResponse2:
		'Sie können Ihre Spende für Freunde oder Familienmitglieder (im Folgenden „Empfänger“ genannt) tätigen. Wenn Sie diese Option wählen, wird Mastercard Donate eine E-Mail in Ihrem Namen an den Empfänger mithilfe der von Ihnen für den Empfänger bereitgestellten E-Mail-Adresse senden. Wenn Sie diese Option nicht nutzen möchten, können Sie diesen Schritt einfach überspringen und mit Ihrer Spende fortfahren. ',
	treesFAQResponse3:
		'Es fallen keine zusätzlichen Kosten an. Es werden jedoch die standardmäßigen Bearbeitungsgebühren für Kreditkartenzahlungen und Gebühren von Worldcoo S.L. von der Spendensumme abgezogen.Worldcoo S.L. (im Folgenden „Worldcoo“ genannt) agiert als Vermittler bei Spendenaktionen und berechnet Conservation International 6 % Verwaltungsgebühren für Ihre Spende und erstattet alle entstandenen standardmäßigen Bearbeitungsgebühren für Transaktionen. Bei Auszahlung Ihrer Spende an Conservation International, rechnet Worldcoo den Betrag zum jeweils gültigen Wechselkurs von Euro in US-Dollar um.',
	treesFAQResponse4:
		'Worldcoo ist eine spanische Gesellschaft, die es E-Commerce-Websites erlaubt, soziale und Kooperationsprojekte mithilfe von Spendenaktionen durchzuführen. Mastercard arbeitet mit Worldcoo zusammen, um Spenden an Conservation International abzuwickeln. Worldcoo sendet eine entsprechende Zahlung in US-Dollar in Höhe Ihrer Spende an Conservation International. Spenden sind nicht erstattungsfähig. Worldcoo erscheint als eingetragener Händler auf Ihrer Kartenabrechnung für die Höhe Ihrer Spende. Conservation International erhält die finanziellen Mittel innerhalb von drei Monaten nach Ihrer Spende. Spenden, die auf der Webseite getätigt werden, sind daher unwiderruflich und es werden keine Rückzahlungen durchgeführt, außer in dem unwahrscheinlichen und bedauerlichen Fall, dass eine der Wohltätigkeitsorganisationen nicht in der Lage ist, Gelder, die über die Mastercard Donate Plattform gesammelt wurden, anzunehmen (z. B. weil sie aufhört zu existieren oder ihren gemeinnützigen Status verliert, etc.). In diesem Fall wird Ihnen Ihre Spende von Worldcoo unverzüglich über die gleiche Zahlungsmethode zurückerstattet, über die Sie Ihre Spende getätigt haben.',
	treesFAQResponse5:
		'Worldcoo erscheint als eingetragener Händler auf Ihrer Kartenabrechnung für die Höhe Ihrer Spende an Conservation International.',
	treesFAQResponse6:
		'Bis zum 15. Mai 2021 verdoppelt Mastercard Spenden an Conservation International, die im Deutschland mithilfe einer Mastercard über die oben verlinkte Spendenseite getätigt wurden. Spende für Spende und Baum für Baum, bis zu einer Gesamtsumme von €194.000 . Weitere Geschäftsbedingungen finden Sie auf der Spendenseite.',
	costPerTreeAproximate: '2 € entsprechen  in etwa den Kosten eines Baumes.',
	treesDonateInputMessage:
		'Wenn Sie mit Mastercard® zahlen, verdoppeln wir Ihre Spende – Baum für Baum und Euro für Euro.**',
	aboutConservationInternational: 'Über Conservation International',
	dedicateToTemplate:
		'Hello! You receive this email because {{donorName}} has given you a donation of {{amount}} {{currency}} for the NGO {{ngoName}} in the campaign {{campaignName}}. This donation has been dedicated to you with the intention of making the world a little better place',
	dedicateToTemplateTitle: 'Schreiben Sie dem Empfänger, dass Sie für ihn gespendet haben.',
	dedicateToWarning:
		'Diese Nachricht wird dem Empfänger an die oben angegebene E-Mail-Adresse gesendet. Ich bestätige, dass ich die Erlaubnis des Empfängers zum Senden dieser Nachricht eingeholt habe.',
	dedicateToRecipientEmail: 'E-Mail-Adresse des Empfängers',
	dedicateToRecipientName: 'Name des Empfängers',
	dedicateDonationTitle: 'Ich möchte meine Baumspende jemandem schenken',
	dedicateDonationMessage: 'I would like to dedicate my donation to someone',
	responsable: 'Controller',
	purpose: 'Purpose',
	legitimation: 'Legitimation',
	recipients: 'Recipients',
	rights: 'Rights',
	telefonicaTermsAndConditionsLink: 'to the terms of the Legal Notice of Fundación Telefónica',
	ngoAdditionalInfoTitle: 'Location and additional information',
	termsButton: 'ICH STIMME ZU',
	id: 'Personalausweis',
	taxId: 'Steuernummer',
	passport: 'Reisepass',
	others: 'Sonstiges',
	campaignAudited: 'Campaign audited by',
	termsAndCons: 'terms of Worldcoo Data Protection',
	ngoTerms: 'Data Protecion terms of',
	haveReadAndAccept: 'I have read, understand and accep the',
	aCampaignBy: 'Eine Kampagne von',
	acceptNgoTermsLink: '{{ngo}} Data Privacy Notice',
	acceptRecurrentTermsLink:
		'I have read, understand and accept the <a class="terms_button" data-open-modal="recurrentTerms" data-modal-classes="terms-modal full-scroll" href="#">NGOs Data Protection terms</a>',
	activities: 'Activities',
	additionalInfo: 'Adresszusatz',
	anyComments: 'Do you have any comments?',
	businessName: 'Company name',
	campaignObjectives: 'Kampagnenziel',
	campaignFunded: 'Campaign funded!',
	campaigns: 'Campaigns',
	cancel: 'Cancel',
	cardBrandNotAccepted: 'This card brand is not accepted.',
	cardRegisteredSuccessfully: 'The card has been successfully registered',
	cardsSupported: 'Cards supported:',
	certificateOnlyValidInExpeditionCountry:
		'The donation certificate will only be valid in the country of origin where the beneficiary entity is registered.',
	certificateNeededData: 'Data necessary to obtain the donation certificate:',
	change: 'Change',
	checkoutSuccess: 'Vielen Dank für Ihre Spende!',
	city: 'Ort',
	collectedFundsDistribution: 'The funds raised will be distributed equally among the following projects:',
	comments: 'Comments',
	company: 'Company',
	confirm: 'Confirm',
	contactData: 'Ihre Kontaktdaten',
	cookiesMessage: 'This website uses cookies. If you continue browsing we will consider you have accepted their use.',
	country: 'Land',
	creditCard: 'Credit card',
	dataReceivedSuccessfully: 'We have correctly received your data.',
	description: 'Beschreibung',
	directBeneficiaries: 'Direct beneficiaries',
	directBeneficiariesDescription: "Those people who have naturally benefited from the campaign's interventions",
	documentNumber: 'Nummer',
	documentType: 'Dokument',
	donationAmount: 'Donation amount',
	donationAmountError: 'Donation amount is not valid',
	donationAmountMinimumIs: 'The minimum amount is {{amount}}',
	donationCertificate: 'Donation certificate',
	donations: 'Donations',
	donors: 'Donors',
	donated: 'Donated',
	donatedOf: 'Donated of',
	donateMonthly: 'Donate monthly',
	donationOnBehalf: 'Make a donation on behalf of',
	door: 'Door',
	email: 'E-Mail',
	fillFollowingFields: 'Fill in the following fields',
	finish: 'Finish',
	floor: 'Floor',
	funded: 'Funded',
	genericCardError: 'An error has occurred with your card.',
	goBack: 'Back',
	identityDocument: 'Identity document',
	indicateDataToIdentify: 'Fill in this information so we can identify your donation.',
	indirectBeneficiaries: 'Indirect beneficiaries',
	indirectBeneficiariesDescription:
		"Those identifiable people who will potentially receive an effect from the campaign's activities",
	inDoubtContactHere: 'Any questions you have you can contact us here:',
	informYouViaMail: 'We will inform you in detail by email.',
	makeDonation: 'Jetzt spenden',
	makeOneTimeDonation: 'Donate',
	makeYourDonation: 'Make your donation',
	manageMyDonations: 'Manage my donations',
	manyThanks: 'Vielen Dank für Ihre Spende!',
	manyThanksExtra: 'Ihr Einsatz wird von uns verdoppelt!',
	modifyAmount: 'Modify the donation amount',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">We have received your request correctly.</p><p>In a few days we will send you an email confirming that we have made the changes you have requested.</p><p>If you have any questions, you can contact us here:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Here you can modify or cancel your donation:',
	moreInfo: 'Further information',
	name: 'Vorname',
	next: 'Next',
	otherAmount: 'Andere Summe',
	overlayError:
		'<p>An error has occurred</p><p>Please try again later or contact us here:</p><p><strong>contact@worldcoo.com</strong></p>',
	particular: 'Individual',
	paymentData: 'Payment data',
	paymentType: 'Form of payment',
	personalData: 'Personal data',
	pleaseFillFields: 'Please fill in the following information:',
	postalCode: 'PLZ',
	province: 'Province',
	raised: 'Raised',
	raisedTillNow: 'Raised until now:',
	recurrentFormError: 'Some error has occurred processing your request. Please try again later or contact us here:',
	region: 'Region',
	repeatEmail: 'Wiederholen Sie die E-Mail',
	repsolEmployeesPortal: 'Employees Giving Platform',
	seeCampaigns: 'ZUR KAMPAGNE',
	send: 'Send',
	share: 'Share',
	sorry: 'We are sorry!',
	stairNumber: 'Stairs',
	step1: 'Step 1',
	step2: 'Step 2',
	step3: 'Step 3',
	step4: 'Step 4',
	stopMakingDonation: 'Stop donating monthly',
	streetName: 'Strasse',
	streetNumber: 'Nummer',
	streetType: 'Street type',
	summary: 'Summary',
	surname: 'Nachname',
	telefonicaUseCorporateMail: '* If you are an active Telefonica employee please use your corporate email.',
	thanks: 'Thank you!',
	typeTheAmount: 'Type the amount',
	unavailableLanguageMessage:
		'We do not have the content of this campaign in english. We are constantly working to provide more content in your language. Thank you for your patience.',
	updatesAndLinks: 'Updates and links',
	validationEqualFields: '{{label}} und {{fieldName}} sind nicht gleich',
	validationIsRequired: '{{label}} Feld ist erforderlich',
	validationValidEmail: '{{label}} Feld ist keine gültige E-Mail',
	viewCampaignInfo: 'ZU KAMPAGNENDETAILS',
	viewInfo: 'View info',
	wantCertificate: 'Ich möchte eine Spendenquittung erhalten',
	wantWorldcooNewsletter: 'I want to receive information about Worldcoo',
	whatIsNewAmount: 'Tell us what is the new amount you want to donate (in {{currency}}):',
	whatYouWantToDo: 'What do you want to do?',
	whoWillBenefit: 'Who will benefit?',
	youCanAlsoDonateOneTime:
		'If you prefer to make a one-time donation to any of them, please start by clicking one of the following links.',
	yourDonationWillBeCharged: 'Your donation will be charged on the 15th of each month.',
	yourRequestIsProcessing: 'Your request is being processed. Wait a few seconds, please.',
	youSureCancelRecurrentDonation: 'Are you sure you want to stop making a monthly donation?',
	ngoTermsTitle: 'Basic information about Data Protection',
	ngoLegitimation: 'The legal basis for handling your data is your consent.',
	ngoRecipients: 'No data shall be transferred to third parties.',
	ngoAdditionalInfoEmail:
		'You can consult the additional and detailed information on Data Protection on the website of each NGO.',
	ngoAdditionalInfoUrl: 'Additional and detailed information on data protection can be found on our website: ',
	amountMustBeGreaterThanZero: 'The amount must be greater than 0',
	amountMustBeLowerThan3000: 'The amount must be less than 3000',
	metafieldsNoTicket: 'Row 0. Donation without entry',
	metafieldsTickets:
		'How many invitations do you need for the concert? Please note that for every €10 donated you get one invitation.',
};
